import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    autoDismiss: Boolean,
    timeout: Number 
  }

  connect() {
    // Set up auto-dismiss if enabled
    if (this.autoDismissValue) {
      this.startAutoDismiss()
    }

    // Add entrance animation from the right
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateX(100%)'
    
    // Trigger entrance animation
    requestAnimationFrame(() => {
      this.element.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out'
      this.element.style.opacity = '1'
      this.element.style.transform = 'translateX(0)'
    })
  }

  disconnect() {
    // Clear any pending timeouts
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  dismiss() {
    this.removeMessage()
  }

  startAutoDismiss() {
    const timeout = this.timeoutValue || 5000
    
    this.autoDismissTimeout = setTimeout(() => {
      this.removeMessage()
    }, timeout)
  }

  removeMessage() {
    // Clear timeout if it exists
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }

    // Animate out to the right
    this.element.style.transition = 'opacity 0.3s ease-out, transform 0.3s ease-out'
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateX(100%)'
    
    // Remove from DOM after animation
    setTimeout(() => {
      if (this.element.parentNode) {
        this.element.remove()
      }
    }, 300)
  }

  // Pause auto-dismiss on hover
  pauseAutoDismiss() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  // Resume auto-dismiss on mouse leave
  resumeAutoDismiss() {
    if (this.autoDismissValue) {
      this.startAutoDismiss()
    }
  }
}